var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backdrop",class:{ opaque: _vm.opaque }},[_c('div',{staticClass:"card-loader"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}}),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }